import React from 'react';
import colors from '../../colors';
import ModalButton from './Buttons/normal/ModalButton';
import ModalContainer from './ModalContainer';

function ConfirmationModal({ isVisible, setIsVisible, mainAction, mainActionHandler, title, color }) {

    const buttonStyles = {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        gap: '15px',
    }

    const handleMainAction = () => {
        mainActionHandler();
        setIsVisible(false);
    }

    return (
        <ModalContainer isVisible={isVisible}
            setIsVisible={setIsVisible}
            title={title} >
            <div style={buttonStyles}>
                <ModalButton color={color || colors.red} onClick={handleMainAction}>{mainAction}</ModalButton>
                <ModalButton color={colors.gray} onClick={() => setIsVisible(false)}>Cancel</ModalButton>
            </div>
        </ModalContainer>
    )
}

export default ConfirmationModal